var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',_vm._g({class:{ disabled: _vm.disabled },attrs:{"href":"#profile-visibility"}},_vm.$listeners),[_c('ChevronDownIcon',{staticClass:"anchor-icon",attrs:{"size":22}}),_vm._v("\n\t"+_vm._s(_vm.t('settings', 'Edit your Profile visibility'))+"\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }